<template>

	<div>

		<section class="outer-pad">

			<Table 
				:headings="headings" 
				:items="table.items" 
				:pages="table.pages"
				:page="table.page"
				:count="table.count"
				:sorted="table.sorted"
				:searchSetup="searchSetup" 
				name="admin-coupons"
				emptyLabel="No coupons were found"
				:loading="!fetched"
				loadingText="Fetching coupons..."
				@pagination="pagination"
				@sort="sort"
				@search="search"
				@selectCoupon="selectCoupon"
				@deleteCoupon="deleteCoupon"
				addNewButtonLabel="Add a new coupon"
				@addNew="showCouponSetup=true"
			/>

		</section>

		<CouponSettings
			:settings="couponSettings"
			@close="closeCouponSettings"
			@save="saveCoupon"
			v-if="showCouponSetup"
		/>

	</div>

</template>

<script>
import Vue from 'vue';
import { mapMutations } from 'vuex'
import ApiService from './../../services/api.service'
import general from './../../utils/general'
import Table from './../../components/Table.vue'
import CouponSettings from './../../components/CouponSettings.vue'
import TableButton from './../../components/Display/TableButton.vue'
export default {
	name: 'AdminCoupons',
	components: {
		Table, CouponSettings
	},
	data() {
		return {
			fetched: false,
			showHeadings:{},
			showCouponSetup: false,
			couponSettings: { 
				code: "", 
				amountOffType: null, 
				joiner: false, 
				joinedCoupons: [] 
			},
			table: {
				items:[],
				page: 1,
				pages: 1,
				sorted: { code: 1 },
				search: {}
			}
		}
	},
	computed: {

		searchSetup () {

			let searchSetup = { 
				searchText: { type: 'text', placeholder: '', showLabel: 'Search Code' }
			};

			return searchSetup;

		},
		headings () {

			let headings = {
				code: { value: 'Code', alignHeading: 'left', alignCell: 'left', sort: -1, click: 'selectCoupon', 'clickVars': ['_id'] }, 
				usageCount: { value: 'Usage Count', alignHeading: 'left', alignCell: 'left', sort: 1, emptyCell: '0' },
				delete: { value: '', component: TableButton, event: 'deleteCoupon', valueForFilter: 'Delete' } 
			};

			return headings;

		}

	},
	methods: {

		...mapMutations('general',['updateLoadingText']),

		deleteCoupon (info) {

			console.log(info._id);

			this.$dialog
					.confirm( "Are you sure you want to delete " + info.code + "?", { okText: 'Yes please', cancelText: 'Cancel',})
					.then(function() {

						this.updateLoadingText("Deleting " + info.code + ", one moment..");

						ApiService.delete( 'admin/coupons/' + info._id )
						.then( function( info ) {

							this.updateLoadingText();
							this.submitSearch ();

						}.bind(this))
						.catch( function(err) {

							this.updateLoadingText();
							this.$snotify.error(err.response.data.error, 'Delete coupon');

						}.bind(this));

					}.bind(this))
					.catch(function() {
						

					});

		},

		closeCouponSettings () {

			general.modalClose();
			this.showCouponSetup = false;
			this.couponSettings = { code: "", amountOffType: null, joiner: false, joinedCoupons: [] };

		},

		saveCoupon (data) {

			this.updateLoadingText("Saving...");

			ApiService.post( 'admin/coupons/add-update', data )
				.then( function( info ) {

				this.$snotify.success( info.data, 'Coupon');
				this.closeCouponSettings ();
				this.updateLoadingText();
				this.submitSearch();

			}.bind(this))
			.catch( function(error) {

				this.$snotify.error(error.response.data.error, 'Coupon');
				this.closeCouponSettings ();
				this.updateLoadingText();
			
			}.bind(this));

		},

		selectCoupon( { _id } ) {

			let coupon = this.table.items.find(coupon => coupon._id.toString() === _id.toString() );

			if ( typeof coupon !== 'undefined' ) {

				this.showCouponSetup = true;
				this.couponSettings = coupon;

			}

		},

		sort(info) {

			Vue.set( this.table, 'sorted', info );
			Vue.set( this.table, 'page', 1 );
			if ( info.init ) { delete this.table.sorted.init; return; }
			this.submitSearch();

		},

		search(info) {

			this.table.page = 1;
			this.table.search = info;
			this.submitSearch();

		},

		pagination(info) {

			this.table.page = info.page;
			this.submitSearch();

		},

		submitSearch () {

			let vars = { page: this.table.page, search: this.table.search, sorted: this.table.sorted };

			ApiService.post( 'admin/coupons', vars )
	        .then( function( info ) {

	            let tableInfo = this.table;

				tableInfo.items = info.data.items;
				tableInfo.count = info.data.count;
				tableInfo.pages = info.data.pages;
				tableInfo.page = info.data.page;

				if ( info.sorted ) {

					tableInfo.sorted = info.sorted;

				}

				this.fetched = true;

				Vue.set(this, 'table', tableInfo);

	        }.bind(this))
	        .catch( function(err) {
	            console.log(err);
	        });

		}
		
	},
	created() {

		this.submitSearch();

	}
}
</script>
